module.exports = __webpack_public_path__ + "img/category3.02ba4846.jpg";